import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from './components/Home.vue';
import ProductCenter from './components/ProductCenter.vue';
import ResourceCenter from './components/ResourceCenter.vue';
import About from './components/About.vue';
import News from './components/News.vue';
import NewsDetail from './components/NewsDetail.vue';   
import AppCenter from './components/AppCenter.vue';
import Result from './components/Result.vue';
import PdfShow from './components/PdfShow.vue';
Vue.use(VueRouter);

const routes = [
  { 
    path: '/', 
    component: Home,
    meta: {
      title: '北京西宝电子技术有限责任公司 - 微波毫米波产品研发与生产',
      description: '北京西宝电子是专业从事微波、毫米波产品研发和生产的高科技公司，产品包括微波器件、天线、波导器件、同轴器件、电缆组件等。',
      keywords: '西宝电子,微波,毫米波,微波器件,毫米波产品,波导器件,天线,同轴器件,微波技术,微波设备'
    }
  },
  { 
    path: '/product-center', 
    component: ProductCenter,
    meta: {
      title: '产品中心 - 微波器件|天线|波导器件|同轴器件 - 西宝电子',
      description: '西宝电子产品中心提供微波器件、毫米波产品、波导器件、天线、同轴器件、电缆及电缆组件等微波毫米波产品。',
      keywords: '微波器件,毫米波产品,波导器件,天线,同轴器件,电缆组件,微波产品,微波技术,微波设备'
    }
  },
  { 
    path: '/resource-center', 
    component: ResourceCenter,
    meta: {
      title: '资源中心 - 北京西宝电子技术有限责任公司',
      description: '西宝电子资源中心提供产品手册、技术文档、应用笔记等下载资源。',
      keywords: '技术文档,产品手册,应用笔记,下载资源'
    }
  },
  { 
    path: '/pdf-show', 
    component: PdfShow,
    meta: {
      title: '文档预览 - 北京西宝电子技术有限责任公司',
      description: '在线预览西宝电子产品手册和技术文档。',
      keywords: 'PDF预览,产品手册,技术文档'
    }
  },
  { 
    path: '/result', 
    component: Result,
    meta: {
      title: '搜索结果 - 北京西宝电子技术有限责任公司',
      description: '西宝电子网站搜索结果页面。',
      keywords: '搜索,产品搜索'
    }
  },
  { 
    path: '/app-center', 
    component: AppCenter,
    meta: {
      title: '微波毫米波应用中心 - 通信|雷达|测试解决方案 - 西宝电子',
      description: '西宝电子提供微波、毫米波通信解决方案、雷达解决方案、测试解决方案等微波毫米波技术应用方案。',
      keywords: '微波应用,毫米波应用,通信解决方案,雷达解决方案,测试解决方案,微波技术,毫米波技术'
    }
  },
  { 
    path: '/about', 
    component: About,
    meta: {
      title: '关于西宝电子 - 微波毫米波器件专业制造商',
      description: '了解北京西宝电子技术有限责任公司，专业从事微波、毫米波器件研发和生产的高科技企业，公司介绍、发展历程、企业荣誉和资质认证。',
      keywords: '关于西宝,西宝电子,公司介绍,企业荣誉,资质认证,微波器件厂家,毫米波器件厂家'
    }
  },
  {
    path: '/news',
    component: News,
    meta: {
      title: '微波毫米波新闻资讯 - 西宝电子',
      description: '西宝电子最新微波、毫米波行业新闻、公司动态、产品资讯。',
      keywords: '微波新闻,毫米波新闻,公司新闻,行业动态,产品资讯,微波行业'
    },
    children: [
      { 
        path: 'industry', 
        component: News,
        meta: {
          title: '微波毫米波行业新闻 - 西宝电子',
          description: '微波、毫米波行业最新动态、技术发展和市场资讯。',
          keywords: '行业新闻,微波行业,毫米波行业,微波技术动态,毫米波技术动态'
        }
      },
      { 
        path: 'company', 
        component: News,
        meta: {
          title: '公司新闻 - 北京西宝电子技术有限责任公司',
          description: '西宝电子公司最新动态、企业新闻和公告。',
          keywords: '公司新闻,企业动态,新闻公告,西宝电子新闻'
        }
      },
      { 
        path: 'product', 
        component: News,
        meta: {
          title: '微波毫米波产品资讯 - 西宝电子',
          description: '西宝电子微波、毫米波产品最新资讯、更新和新品发布。',
          keywords: '产品资讯,产品更新,新品发布,微波产品,毫米波产品'
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

// 全局路由守卫 - SEO优化和404处理
router.beforeEach((to, from, next) => {
  // 检查路由是否存在
  const matched = to.matched.length > 0;
  
  if (!matched) {
    // 路由不存在，重定向到首页
    next({ path: '/' });
    return;
  }
  
  // 更新页面SEO信息
  const meta = to.meta || {};
  
  // 更新标题
  if (meta.title) {
    document.title = meta.title;
  }
  
  // 更新meta description
  let descMeta = document.querySelector('meta[name="description"]');
  if (descMeta && meta.description) {
    descMeta.setAttribute('content', meta.description);
  }
  
  // 更新meta keywords
  let keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (keywordsMeta && meta.keywords) {
    keywordsMeta.setAttribute('content', meta.keywords);
  }
  
  // 更新canonical链接
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink) {
    canonicalLink.setAttribute('href', 'https://www.beijingxibao.com' + to.path);
  }
  
  // 百度统计推送
  if (typeof window !== 'undefined' && window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath]);
  }
  
  next();
});

export default router;